export default {
    'realtime_revenue': 'Revenue({unit})',
    'realtime_revenue_title': 'Realtime Revenue',
    'realtime_steam_title':'Realtime Steam Units',
    'realtime_steam_units':'Steam Units',
    'realtime_steam_realtime_steam_title': 'Realtime Daily Accumulated Steam Units (1h)',
    'realtime_revenue_realtime_revenue_title': 'Realtime Daily Accumulated Revenue (10 min)',
    'realtime_revenue_realtime_revenue_chart_title': 'Realtime Daily Accumulated Revenue (10 min)',
    'realtime_revenue_realtime_revenue_download': 'Realtime Daily Accumulated Revenue (10 min)',
    'realtime_revenue_realtime_revenue_Statistical':'Statistical Time',
    'realtime_revenue_chart_explain':'Due to the impact of midas data calculation and return time, the overall revenue data was delayed by about 40 minutes.',
    'realtime_revenue_realtime_revenue_Time':'Time',
    'realtime_info_download_settings': 'Download Settings',
    'realtime_info_download_by_hour': 'By hour',
    'realtime_info_download_by_5_min': 'By 5 min',
    'realtime_info_download_by_10_min': 'By 10 min',
    'realtime_info_download_time': 'Time',
    'realtime_info_download_sort': 'Sort',
    'realtime_info_download_sort_up': 'Ascending',
    'realtime_info_download_sort_down': 'Descending',
    'realtime_info_download_metrics': 'Metrics',
    'realtime_info_download_metrics_realtime_detail_data': 'Realtime Detail Data (Right Trends)',
    'realtime_info_download_metrics_top_change_by_country': 'Top Change by Country (Left table)',
    'realtime_info_download_file_format': 'File Format',
    'realtime_info_steam_chart_explain':'The data comes from the Steam backend, with a one-hour delay on Steam platform data.In addition, current unit data excludes third-party sales and activations via activation codes.',
}
